<div class="home-slides owl-carousel owl-theme">
    <div class="main-banner-four item-bg-1">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="banner-image">
                                <img src="assets/img/1300_1050_training_banner.png" alt="banner-img">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="hero-content">
                                <h1>Training in Inclusive Media and Filmmaking</h1>
                                <p>At the heart of our work is comprehensive training open to all aspiring creators.
                                </p>
                                <a routerLink="#" class="btn btn-primary">Read More</a>
                                <a href="https://www.youtube.com/watch?v=Pf8Z9hS2gLE" class="video-btn">Play Now<i
                                        class="icofont-play-alt-3"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-banner-four item-bg-2">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="banner-image">
                                <img src="assets/img/1300_1050_expanding_content_banner.png" alt="banner-img">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="hero-content">
                                <h1>Expanding Content Creation Services</h1>
                                <p>Building on our training foundation, we will soon extend our services to include
                                    professional content creation such as corporate films, educational videos,
                                    documentaries, and sports-related media projects.</p>
                                <a routerLink="#" class="btn btn-primary">Read More</a>
                                <a href="https://www.youtube.com/watch?v=fhoPkoenV58" class="video-btn">Play Now<i
                                        class="icofont-play-alt-3"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="features-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="repair-about-image">
                    <img src="assets/img/about_us_1.png" alt="image">
                    <img src="assets/img/about_us_2.png" alt="image">
                </div>
            </div>

            <div class="col-lg-7 col-md-12">
                <div class="repair-about-content">
                    <div class="section-title">
                        <span>About Us</span>
                        <h3>Creating Content Celebrating Champions</h3>
                        <p>Welcome to AM Media and Sports Pvt Ltd—where media and sports come together to inspire,
                            educate, and empower communities through innovative storytelling and dynamic sporting
                            experiences. We are a forward-thinking platform dedicated to making content and sports
                            accessible, inclusive, and impactful for everyone.</p>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="single-about-box">
                                <i class="icofont-eye-open"></i>
                                <h3>Our Vision</h3>
                                <p>
                                    Our vision is to become a leading platform where media and sports converge to
                                    inspire, educate, and empower communities.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="single-about-box">
                                <i class="icofont-dart"></i>
                                <h3>Our Mission</h3>
                                <p>
                                    Our mission is to empower communities through innovative content creation and
                                    dynamic sporting events.
                                </p>
                            </div>
                        </div>
                    </div>
                    <a routerLink="/about" class="read-more-btn">Read More About Us</a>
                </div>
            </div>
        </div>

        <div class="row ptb-100 align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="features-text">
                    <h3>Training in Inclusive Media and Filmmaking</h3>
                    <p>At the heart of our work is comprehensive training open to all aspiring creators. We offer
                        specialized courses in audio description, translation, voice acting, transcription, and audio
                        descriptive sports commentary. Our filmmaking courses cover a wide range of skills essential for
                        creating impactful corporate films, educational films, documentaries, and more.
                    </p>
                    <ul>
                        <li>While our
                            initial focus is on training, these programs are designed to empower people from all
                            backgrounds.</li>
                        <li>Especially persons with disabilities, women, and rural youth. helping them gain skills that
                            translate into meaningful careers.</li>
                    </ul>
                    <a routerLink="/about" class="btn btn-primary">Read More</a>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img src="assets/img/training_and_media_about.png" alt="image">
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="img">
                    <img src="assets/img/expanding_content_creation_about.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="features-text mb-0">
                    <h3>Expanding Content Creation Services</h3>
                    <p>Building on our training foundation, we will soon extend our services to include professional
                        content creation such as corporate films, educational videos, documentaries, and sports-related
                        media projects.</p>
                    <ul>
                        <li>Our goal is to produce high-quality, inclusive content that celebrates champions and tells
                            stories that matter.</li>
                    </ul>
                    <a routerLink="/about" class="btn btn-primary">Read More</a>
                </div>
            </div>
        </div>
    </div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
</section>

<section class="services-area bg ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Your Media, Your Story — Done Right.</span>
            <h3>AM Media & Sports: Let’s Create Magic Together!</h3>
            <p>Celebrating Champions. Uniting India. One Game at a Time.</p>
            <a routerLink="#" class="read-more-btn">view more services</a>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-chart-arrows-axis"></i>
                    </div>
                    <h3>Sports</h3>
                    <p>
                        We believe sport is more than competition - it’s a powerful force
                        that unites communities, empowers individuals, and inspires change.
                    </p>
                    <a href="/sports-service" class="read-more-btn">Read More</a>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-location-arrow"></i>
                    </div>
                    <h3>Media</h3>
                    <p>
                        We believe in the power of stories. The kind that inspire, connect, and
                        celebrate everyday heroes.Powered by passionate talent.
                    </p>
                    <a href="/media-service" class="read-more-btn">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="course" *ngIf="latestCoursesList.length > 0" class="pricing-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="section-title">
            <span>Courses</span>
            <h3>Not any hidden charges, choose your course</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of
                the industry.</p>
            <a routerLink="/about" class="read-more-btn">View More Courses</a>
        </div>

        <div id="monthly" class="wrapper-full">
            <div class="row justify-content-center">
                <div *ngFor="let course of latestCoursesList" class="col-lg-6 col-md-6">
                    <div class="cs-pricing-card">
                        <div class="pricing-header">
                            <h3 class="roboto-font">{{course.courseTitle}}</h3>
                        </div>
                        <div class="pricing-price roboto-font">₹{{course.courseAmount | number:'1.2-2'}} <span>/ per
                                month</span></div>
                        <p>{{course.courseDescription}}</p>
                        <ul class="pricing-list">
                            <li><i class="icofont-check-alt"></i> Course Duration -
                                {{course.courseFinishTime}}<span></span>
                            </li>
                            <li><i class="icofont-check-alt"></i> Authors - {{course.courseAuthors}}</li>
                            <li><i class="icofont-check-alt"></i> Tags - {{course.courseTags}}</li>
                        </ul>
                        <div class="pricing-btn">
                            <a href="#" class="default-btn roboto-font">Buy Now</a>
                            <a [href]="course.courseSampleFilePath" target="_blank"
                                class="default-btn roboto-font mx-4">View Details</a>
                        </div>

                        <div class="pricing-shape">
                            <img [src]="course.courseImagePath" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Start Event Wrap Area -->
<div *ngIf="latestEventsList.length > 0" class="blog-wrap-area pt-100 pb-75">
    <div class="container">
        <div class="section-title">
            <span>Events</span>
            <h3>Explore, Learn And Stay Up <b>To Date</b> With The Latest Event</h3>
            <a routerLink="#" class="read-more-btn">view more events</a>
        </div>

        <div class="row justify-content-center align-items-stretch">
            <div *ngFor="let event of latestEventsList" class="col-lg-4 col-md-6">
                <div class="event-single-work blog-wrap-card">
                    <ul class="post-meta">
                        <li><i class="icofont-calendar"></i>{{event?.eventDate | date:'d MMMM y'}}</li>
                        <li><i class="icofont-eye"></i> {{event?.registeredUserCount}} Views</li>
                    </ul>
                    <h3 class="roboto-font">
                        <a href="#">{{event?.eventTitle}}</a>
                    </h3>
                    <p>{{event?.eventDescription}}</p>
                    <div class="info d-flex align-items-center">
                        <img src="assets/img/user1.png" alt="image">

                        <div class="title">
                            <h4 class="roboto-font"><a href="#">{{event?.eventOrganizer}}</a></h4>
                        </div>
                    </div>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#eventRegisterModal" class="popup-btn"
                        (click)="openEventRegistrationModal(event?._id)">
                        <i class="icofont-plus"></i>
                    </a>
                </div>
            </div>
        </div>

        <!--Event user registration modal-->
        <div class="modal right fade sidebarModal" id="eventRegisterModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row align-items-center">
                            <div class="col-lg-12 col-md-12">
                                <div class="analysis-form">
                                    <h3>Event Registration</h3>
                                    <form [formGroup]="eventRegisterForm">
                                        <div class="form-group">
                                            <input formControlName="firstName" type="text" placeholder="First Name*"
                                                class="form-control">
                                            <div class="form-error-message"
                                                *ngIf="eventRegisterForm.get('firstName')?.invalid && eventRegisterForm.get('firstName')?.touched">
                                                FirstName is required and must be enter valid characters.
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <input formControlName="lastName" type="text" placeholder="Last Name*"
                                                class="form-control">
                                            <div class="form-error-message"
                                                *ngIf="eventRegisterForm.get('lastName')?.invalid && eventRegisterForm.get('lastName')?.touched">
                                                LastName is required and must be enter valid characters.
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <input formControlName="email" type="email" placeholder="Email*"
                                                class="form-control">
                                            <div class="form-error-message"
                                                *ngIf="eventRegisterForm.get('email')?.invalid && eventRegisterForm.get('email')?.touched">
                                                Email is required and must be enter valid email address.
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <input formControlName="mobile" type="text" placeholder="Phone*"
                                                class="form-control">
                                            <div class="form-error-message"
                                                *ngIf="eventRegisterForm.get('email')?.invalid && eventRegisterForm.get('email')?.touched">
                                                Email is required and must be enter valid email address.
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <button type="submit" class="btn btn-primary"
                                                    (click)="saveUserRegistration()">Submit</button>
                                            </div>
                                            <div class="col-lg-6">
                                                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal"
                                                    aria-label="Close"><span aria-hidden="true">Close</span></button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Event Wrap Area -->

<!--Video Gallery-->
<section class="project-area mt-5 ptb-0">
    <div class="container">
        <div class="section-title">
            <span>Video's</span>
            <h3>See What We Do - Real videos, real people, real results.</h3>
            <p>Explore how we bring ideas to life at a time. Dive into our service highlights and media stories. </p>
            <!-- <a routerLink="#" class="read-more-btn">view more images</a> -->
        </div>
    </div>
    <div class="shorting">
        <div class="row m-0">
            <div class="col-lg-4 col-md-6 col-sm-6 mix brand p-0">
                <div class="single-work">
                    <iframe width="492" height="369" src="https://www.youtube.com/embed/zeVx2_EP6Ys"
                        title="YES WE TOO CAN !!" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=zeVx2_EP6Ys" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix design p-0">
                <div class="single-work">
                    <iframe width="656" height="369" src="https://www.youtube.com/embed/NZO4DZ1-ho4"
                        title="I started a movement &quot;Yes, We Too Can !!!&quot; in 2010" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=NZO4DZ1-ho4" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix graphic p-0">
                <div class="single-work">
                    <iframe width="492" height="369" src="https://www.youtube.com/embed/GpnaBJcGUps"
                        title="Ripples Chennai 2012" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=GpnaBJcGUps" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix photoshop p-0">
                <div class="single-work">
                    <iframe width="656" height="369" src="https://www.youtube.com/embed/S5-a8v73Ut8"
                        title="2nd National Wheelchair Basketball Championship" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=S5-a8v73Ut8" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix design p-0">
                <div class="single-work">
                    <iframe width="656" height="369" src="https://www.youtube.com/embed/hE-b8DPlL8o"
                        title="Ep 01 - &#39;Hoops On Wheels&#39; Ft. Dee MC | UBER X NBA Hoop Nation" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=hE-b8DPlL8o" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix illustrator p-0">
                <div class="single-work">
                    <iframe width="492" height="369" src="https://www.youtube.com/embed/X4IFEMEyC5I"
                        title="Height of Confidence 1" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=X4IFEMEyC5I" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix photoshop p-0">
                <div class="single-work">
                    <iframe width="492" height="369" src="https://www.youtube.com/embed/vksPafcu-L0"
                        title="Height of Confidence 2" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=vksPafcu-L0" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix design p-0">
                <div class="single-work">
                    <iframe width="671" height="369" src="https://www.youtube.com/embed/Pf8Z9hS2gLE"
                        title="India First AOZ paralympic qualifications" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=Pf8Z9hS2gLE" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix illustrator p-0">
                <div class="single-work">
                    <iframe width="656" height="369" src="https://www.youtube.com/embed/DnatgcAWqas"
                        title="Madhavi Latha Prathigudupu" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=DnatgcAWqas" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix photoshop p-0">
                <div class="single-work">
                    <iframe width="656" height="369" src="https://www.youtube.com/embed/4JPl77vcnks"
                        title="Honest Talk with Ms. Madhavi Latha Prathigudupu on Swimming Against The Tide"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=4JPl77vcnks" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix design p-0">
                <div class="single-work">
                    <iframe width="691" height="380"
                        src="https://www.youtube.com/embed/n27Fz0PxFmc?list=PLghPeHmJEckenry5HFiLi6Mgdr7vgKFJp"
                        title="GITEX LIVE 2022" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://youtube.com/playlist?list=PLghPeHmJEckenry5HFiLi6Mgdr7vgKFJp&si=ZLPuSpmr3O2I1H7m
" class="link-btn video-btn"><i class="icofont-play-alt-3"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix illustrator p-0">
                <div class="single-work">
                    <iframe width="656" height="369" src="https://www.youtube.com/embed/fhoPkoenV58"
                        title="Importance of Sports among the Disabled | Madhavi Latha | TEDxSRMRamapuram"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <a href="https://www.youtube.com/watch?v=fhoPkoenV58" class="link-btn video-btn"><i
                            class="icofont-play-alt-3"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="false" class="project-area ptb-0">
    <div class="container">
        <div class="section-title">
            <span>Gallery</span>
            <h3>We’ve done lot’s of work, Let’s Check some from here</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of
                the industry.</p>
            <a routerLink="#" class="read-more-btn">view more images</a>
        </div>

        <div class="shorting-menu">
            <button class="filter" data-filter="all">All</button>
            <button class="filter" data-filter=".brand">Brand</button>
            <button class="filter" data-filter=".design">Design</button>
            <button class="filter" data-filter=".graphic">Graphic</button>
            <button class="filter" data-filter=".photoshop">Photoshop</button>
            <button class="filter" data-filter=".illustrator">Illustrator</button>
        </div>
    </div>
    <div class="shorting">
        <div class="row m-0">
            <div class="col-lg-4 col-md-6 col-sm-6 mix brand p-0">
                <div class="single-work">
                    <img src="assets/img/work-img1.jpg" alt="work-img">
                    <div class="work-content">
                        <h3>Bubble Wrap</h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Brand</a></li>
                        </ul>
                    </div>
                    <a routerLink="#" class="link-btn"><i class="icofont-link"></i></a>
                    <a href="assets/img/work-img1.jpg" class="popup-btn"><i class="icofont-plus"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix design p-0">
                <div class="single-work">
                    <img src="assets/img/work-img2.jpg" alt="work-img">
                    <div class="work-content">
                        <h3>Fluffernutter</h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Brand</a></li>
                        </ul>
                    </div>
                    <a routerLink="#" class="link-btn"><i class="icofont-link"></i></a>
                    <a href="assets/img/work-img2.jpg" class="popup-btn"><i class="icofont-plus"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix graphic p-0">
                <div class="single-work">
                    <img src="assets/img/work-img3.jpg" alt="work-img">
                    <div class="work-content">
                        <h3>Crock-Pot</h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Brand</a></li>
                        </ul>
                    </div>
                    <a routerLink="#" class="link-btn"><i class="icofont-link"></i></a>
                    <a href="assets/img/work-img3.jpg" class="popup-btn"><i class="icofont-plus"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix photoshop p-0">
                <div class="single-work">
                    <img src="assets/img/work-img4.jpg" alt="work-img">
                    <div class="work-content">
                        <h3>Chapstick </h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Brand</a></li>
                        </ul>
                    </div>
                    <a routerLink="#" class="link-btn"><i class="icofont-link"></i></a>
                    <a href="assets/img/work-img4.jpg" class="popup-btn"><i class="icofont-plus"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix design p-0">
                <div class="single-work">
                    <img src="assets/img/work-img5.jpg" alt="work-img">
                    <div class="work-content">
                        <h3>Kleenex</h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Brand</a></li>
                        </ul>
                    </div>
                    <a routerLink="#" class="link-btn"><i class="icofont-link"></i></a>
                    <a href="assets/img/work-img5.jpg" class="popup-btn"><i class="icofont-plus"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 mix illustrator p-0">
                <div class="single-work">
                    <img src="assets/img/work-img6.jpg" alt="work-img">
                    <div class="work-content">
                        <h3>Ping-Pong</h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Brand</a></li>
                        </ul>
                    </div>
                    <a routerLink="#" class="link-btn"><i class="icofont-link"></i></a>
                    <a href="assets/img/work-img6.jpg" class="popup-btn"><i class="icofont-plus"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="false" class="testimonial-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="section-title">
            <span>Testimonial</span>
            <h3>What our client are saying</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of
                the industry.</p>
        </div>
        <div class="feedback-slides owl-carousel owl-theme">
            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar1.jpg" alt="client">
                    </div>
                    <h4>Josh Buttler</h4>
                    <span>Web Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar2.jpg" alt="client">
                    </div>
                    <h4>David Andy</h4>
                    <span>Web Designer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar3.jpg" alt="client">
                    </div>
                    <h4>Lina D'Souja</h4>
                    <span>QA Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar1.jpg" alt="client">
                    </div>
                    <h4>Sarah Taylor</h4>
                    <span>Team Lead</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar2.jpg" alt="client">
                    </div>
                    <h4>John Smith</h4>
                    <span>Web Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar3.jpg" alt="client">
                    </div>
                    <h4>Eva Lucy</h4>
                    <span>PHP Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et
                    dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>
        </div>
    </div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
</section>

<section id="blog" *ngIf="latestBlogsList.length > 0" class="blog-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Our Blogs</span>
            <h3>Latest Blog Posts</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of
                the industry.</p>
            <a routerLink="#" class="read-more-btn">View More Blogs</a>
        </div>

        <div class="row">
            <div *ngFor="let blog of latestBlogsList" class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-repair-blog-post">
                    <div class="blog-image">
                        <a routerLink="#"><img src="assets/img/blog-one.jpg" alt="image"></a>
                        <div class="tags"><a href="#">{{blog.blogCategory}}</a></div>
                    </div>

                    <div class="blog-content">
                        <h3><a routerLink="#">{{blog.blogTitle}}</a></h3>
                        <ul>
                            <li>{{blog.created_date | date:'d MMMM y'}}</li>
                            <li>by: <a href="#" class="truncate">{{blog.blogPostedBy}}</a></li>
                            <li><a routerLink="#" class="read-more-btn">Read More</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>